import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useSettingsAuth } from '@/app/settings-auth'
import { SettingsLoginPage } from '@/components/settings/settings-login-page'

/** Internal admin tool: own login (not the native session); see `@/app/settings-auth`. */
export const Route = createFileRoute('/settings')({
  component: SettingsLayout,
})

function SettingsLayout() {
  const token = useSettingsAuth((s) => s.token)
  return token ? <Outlet /> : <SettingsLoginPage />
}
